import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

import { cn } from "@/lib/utils/cn";

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      // `block` so a field label always occupies its own line: Radix renders a
      // native <label> (display: inline), which otherwise flows onto the same
      // line as an inline-level control (e.g. an `inline-flex` segmented/toggle
      // group), reading as "squished". twMerge lets any consumer that needs an
      // inline/flex label override this via className.
      "block text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className,
    )}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
